import { IReview } from '@/app/[locale]/_types'
import {
  DialogRoot,
  DialogContent,
  DialogBody,
  DialogCloseTrigger,
  DialogHeader,
} from '@/components/ui/dialog'
import { Stack, StackSeparator, Text } from '@chakra-ui/react'
import React from 'react'
import Card from './components/Card'
import { useTranslations } from 'next-intl'

const CommentDesktop = ({
  open,
  onClose,
  reviews,
}: {
  open: boolean
  onClose: () => void
  reviews?: IReview[]
}) => {
  const t = useTranslations()

  return (
    <DialogRoot open={open} size="sm" onOpenChange={onClose}>
      <DialogContent overflow="hidden">
        <DialogHeader>
          <Text textAlign="center" fontSize="lg" fontWeight={700}>
            {t('reviews')}
          </Text>
        </DialogHeader>
        <DialogBody overflowY="auto">
          <Stack separator={<StackSeparator />}>
            {reviews && reviews?.length > 0 ? (
              reviews?.map((el) => <Card key={el.id} data={el} />)
            ) : (
              <Text
                textAlign={'center'}
                my={4}
                fontSize={'lg'}
                fontWeight={600}
              >
                {t('no_reviews')}
              </Text>
            )}
          </Stack>
        </DialogBody>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  )
}

export default CommentDesktop
